import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import ImagesWithZoom from "@/shared/components/ui/Images/ImagesWithZoom";
import { IDataPreventa } from "@/shared/interfaces";
import { Visibility } from "@mui/icons-material";
import { Button, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";

type ModalFotoContratoComponenteProps = {
  preventa_data: IDataPreventa;
}

type imagenData = {
  url: string;
  tipo: string;
}

export default function ModalFotoContratoComponente({ preventa_data }: ModalFotoContratoComponenteProps) {

  const [open, setOpen] = useState(false);
  const [imagenData, setImagenData] = useState<imagenData[]>([]);


  useEffect(() => {
    const images: imagenData[] = [
      {
        tipo: 'Identificación Delantera',
        url: `${preventa_data.url_foto_identificacion_delantera}?v=${new Date().getTime()}` || '',
      },
      {
        tipo: 'Identificación Posterior',
        url: `${preventa_data.url_foto_identificacion_posterior}?v=${new Date().getTime()}` || '',
      },
    ];

    if (preventa_data.url_foto_aceptacion) {
      images.push({
        tipo: 'Foto de Aceptación',
        url: `${preventa_data.url_foto_aceptacion}?v=${new Date().getTime()}`,
      });
    }

    images.push(
      {
        tipo: 'Cuenta Bancaria',
        url: `${preventa_data.url_foto_cuenta_bancaria}?v=${new Date().getTime()}` || '',
      },
      {
        tipo: 'Tarjeta',
        url: `${preventa_data.url_foto_tarjeta}?v=${new Date().getTime()}` || '',
      }
    );

    setImagenData(images);

  }, [preventa_data])



  return (
    <>
      <Button
        color="primary"
        endIcon={<Visibility />}
        onClick={() => {
          setOpen(true)
        }}
      >
        Ver
      </Button>
      {
        open && (
          <ScrollableDialogProps
            onCloseIcon={() => setOpen(false)}
            open={open}
            title="Imágenes Subidas"
            minWidth="70%"
            contentNode={
              <Grid container spacing={8} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                {
                  imagenData.map((value, index) => {
                    if(value.url.includes(".pdf"))
                      return <Grid key={index} item xs={6} md={3} textAlign={'center'}>
                        <Typography variant="subtitle2" style={{ padding: '10px 0px', fontWeight: 'bold' }}>{value.tipo}</Typography>
                        <a href={value.url} target="_blank">
                          <Button variant="contained">
                            Ver Documento PDF
                          </Button>
                        </a>
                    </Grid>
                      
                      // return <a href={value.url} style={{backgroundColor:"orange"}}>Documento PDF</a>
                    if (value.url && value.url.includes("sigefstorage"))
                      return <Grid key={index} item xs={6} md={3} textAlign={'center'}>
                        <Typography variant="subtitle2" style={{ padding: '10px 0px', fontWeight: 'bold' }}>{value.tipo}</Typography>
                        <ImagesWithZoom
                          src={value.url}
                          alt={value.tipo}
                        />
                      </Grid>
                    
                  })

                }



              </Grid>
            }
          />
        )
      }
    </>
  )

}